<nz-input-group nzAddOnBefore="{{ currency?.code }}" class="width-100">
  <input title="Currency Rate" nz-input [(ngModel)]="value" (ngModelChange)="onModelChange($event)" app-number-input
    [precision]="8" [tabindex]="tabindex" [defaultValue]="1" [readOnly]="readonly"
    [class]="(readonly ?  'bg-grey-lighter ' : ' ') + class" />
</nz-input-group>